import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component } from '@angular/core'

@Component({
    selector: 'ca-helpdesk-dialog',
    templateUrl: './helpdesk-dialog.component.html',
})
export class HelpdeskDialogComponent extends CaDialogComponent<{}, boolean> {
}